import Vue from 'vue'
import VueBing from '~/utils/plugins/bing'

export default ({ $config }) => {
  if ($config.production) {
    Vue.use(VueBing, { tagId: '148011778' })
  }
}
